
import "./App.css";
import Game from './Components/Game';
import CardGallery from './Components/CardGallery';
import GameList from './Components/GameList';
import Stats from './Components/Stats';
import Admin from './Components/Admin';
import Profile from './Components/Profile';
import { ImageProvider } from "./context/ImageContext";

// Which page the address asks for
const Page = (params) => params.has('cards') ? <CardGallery/> : params.has('game') || params.has('new') ? <Game/>
    : params.has('stats') ? <Stats/> : params.has('admin') ? <Admin/> : params.has('profile') ? <Profile/> : <GameList/>;

function App() {

    return (
        <ImageProvider>
        <div className="App">
            {/* ?cards: the card test page; ?game=N (or ?new, a new one): a game; ?stats: the stats; ?admin: the admin page; ?profile: your profile; otherwise the games */}
            {Page(new URLSearchParams(window.location.search))}
        </div>
        </ImageProvider>
    );
}

export default App;